<style lang="scss" src='./UserAvatar.scss' scoped ></style>
<template src="./UserAvatar.html"></template>

<script>
export default {
  name: 'UserAvatar',
  components: {},
  props: {
    user: {
      type: Object,
      required: false,
    },
    includeUnassignedTxt: {
      type: Boolean,
      required: false,
    },
    showName:{
      type: Boolean,
      default: false,
    },
    size:{
      type: String,
    },
    multiple:{
      type: Boolean,
      default: false,
    },
  },
  data() {
    return ({
    });
  },
  computed: {
    id(){
      let tempId = 'avatar' + this._uid ;
      return tempId;
    }
  },

  methods: {},

  beforeCreate() {},

  created() {},

  mounted() {},

  beforeDestroy() {},

};
</script>
